
import React from 'react';
import ServiceCard from './ServiceCard';
import { useTranslation } from 'react-i18next';

const ServiceSecOne = ({ className }) => {
  const { t } = useTranslation();

  return (
    <section className={className} id="service-sec">
        <div
            className="shape-mockup bg-gradient-shape1"
            data-top="15%"
            data-left={0}
        />
        <div className="container">
            <div className="title-area text-center">
            <span className="sub-title" data-cue="slideInUp">{t('sections.serviceSecOne.sub_title','Our Top-Notch Services')}</span>
            <h2 className="sec-title" data-cue="slideInUp">{t('sections.serviceSecOne.title','Comprehensive Cybersecurity <br /> Solutions')}</h2>
            </div>
            <div className="row gy-4 justify-content-center">
                <ServiceCard className="col-lg-4 col-md-6" limit={6} />
            </div>
        </div>
    </section>
  );
};

export default ServiceSecOne;